<template>
    <a-image v-if="!preview"
    :alt="alt"
    :fallback="customFallback"
    :height="height"
    :placeholder="placeholder"
    :preview="false"
    :src="thumbImgSrc"
    :width="width"
    loading="lazy"
    v-bind="$attrs"
    >
    </a-image>
    <template v-else>
        <a-image v-if="!showViewImg"
            :alt="alt"
            :fallback="customFallback"
            :height="height"
            :placeholder="placeholder"
            :preview="false"
            :src="thumbImgSrc"
            :width="width"
            v-bind="$attrs"
            @click="showViewImg =!showViewImg"
            >
        </a-image>
        <a-image v-else
            :alt="alt"
            :fallback="customFallback"
            :height="height"
            :placeholder="placeholder"
            :preview="fullPreview"
            :src="previewImgSrc"
            :width="width"
            v-bind="$attrs"
            >
        </a-image>
    </template>
</template>
<script>
import { ref, computed, reactive } from "vue";
import { Image } from "ant-design-vue";
export default ({
    name:"CImage",
    components:{
        AImage:Image
    },
    props:{
        alt:[String],
        fallback:[String],
        height:[String,Number],
        placeholder: null,
        preview: {
            type: Boolean,
            default: true
        },
        src:[String],
        width:[String,Number],
        thumbWidth:[Number],
        thumbHeight:[Number],
        disPreviewProcess:{
            type: Boolean,
            default: false
        },
        ossHeight:{
            type: [String,Number],
            default: 600
        },
        ossWidth:{
            type: [String,Number],
            default: 600
        },
        disThumbProcess:{
            type: Boolean,
            default: false
        }
    },
    setup(props,_ref){
        const showViewImg = ref(false);
        const customFallback = computed(()=>
            (props.fallback)?props.fallback:"data:image/png;base64,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"
        );
        
        const getOssProcessVal=(tWidth,tHeight)=>{
            if((!tWidth) || tWidth < 0){
                tWidth = 60;
            }
            if((!tHeight) || tHeight < 0){
                tHeight = 60;
            }  
            return 'image/resize,m_lfit,h_'+tHeight+',w_'+tWidth;
        }

        const addQueryString = function (url, key, value) {
            if (url) {
                var hostAndPath = url;
                var queryString = "";
                var hash = "";
                var arr = [];
                if (hostAndPath.indexOf("#") >= 0) {
                    arr = hostAndPath.split("#");
                    hostAndPath = arr[0];
                    hash = arr[1];
                }
                if (hostAndPath.indexOf("?") >= 0) {
                    arr = hostAndPath.split("?");
                    hostAndPath = arr[0];
                    queryString = arr[1];
                }
                if ((queryString || "").trim() !== "") {
                    queryString += "&" + encodeURIComponent(key + "") + "=" + encodeURIComponent(value + "");
                } else {
                    queryString = encodeURIComponent(key + "") + "=" + encodeURIComponent(value + "");
                }
                var returnUtl = hostAndPath + "?" + queryString;
                if (hash) {
                    returnUtl += "#" + hash;
                }
                return returnUtl;
            }
            return url;
        };

        const previewImgSrc = computed(() => props.disPreviewProcess ? props.src : addQueryString(props.src,"x-oss-process",getOssProcessVal(props.ossWidth,props.ossHeight)));

        const fullPreview = ref({
            visible:true
        });

        if(props.preview){
            if(props.preview.onVisibleChange){
                fullPreview.onVisibleChange = props.preview.onVisibleChange;
            }
            if( props.preview.getContainer){
                fullPreview.getContainer = props.preview.getContainer;
            }    
        }

        const thumbImgSrc = computed(()=> props.disThumbProcess ? props.src : addQueryString(props.src,"x-oss-process",getOssProcessVal(props.thumbWidth,props.thumbHeight)));

        return {
            showViewImg,
            thumbImgSrc,
            previewImgSrc,
            fullPreview,
            customFallback
        };
    }
})
</script>